import React from 'react';
import { connect, useSelector } from 'react-redux';
import { updateEpikBox } from '../../../actions/EpikBoxes';
import './ReportListTable.css';

const ReportListRow = ({ report, onBoxClick }) => {
  const user = useSelector(state => state.AppState.user);

  // The following reports need to be removed (Hide from Everyone except engineering) from the system until we have a method to pull proper live data on devices. 
  if (['BLR', 'INT', 'AFR', 'NSR', 'BOL', 'BAD', 'UTR'].includes(report?.reportSymbol) && !user?.epikEngineering) {
    return null;
  }

  const allowedAssetsReportRoles = ['superAdmin', 'companyGroupAdmin'];
  if (['PAR', 'SIM'].includes(report?.reportSymbol) && !allowedAssetsReportRoles?.includes(user?.role)) {
    return null;
  }

  // Ensure Customer permissions group doesn't have access to internal reports
  if (['PAR', 'SIM'].includes(report?.reportSymbol) && user?.permissionsGroup === 'Customer') {
    return null;
  }

  if (['OOBM_TTY'].includes(report?.reportSymbol) && !allowedAssetsReportRoles?.includes(user?.role)) {
    return null;
  }
  
  if (['BLR'].includes(report?.reportSymbol) && !user?.epikEngineering) {
    return null;
  }

  const fieldClicked = () => {
    onBoxClick(report);
  };

  return (
    <tr className="row-hover">
      <td onClick={fieldClicked} className="report-name-cell">
        <span>{report.reportName || ''}</span>
        {/* {report.isInternal && (
          <span className="internal-label">
            INTERNAL
          </span>
        )} */}
      </td>
      <td>{report.owner}</td>
      {user.permissionsGroup !== "Customer" && (
        <td>
          {report.isInternal ? (
            <span className="internal-label">Internal Only</span>
          ) : (
            'Customer Facing'
          )}
        </td>
)}
    </tr>
  );
};

const mapDispatchToProps = dispatch => ({
  updateBox: (token, report) => dispatch(updateEpikBox(token, report)),
});

export default connect(
  null,
  mapDispatchToProps,
)(ReportListRow);
